/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */

import ResetPassword from '../components/common/ResetPassword';
import AuthLayout from '../components/common/AuthLayout';
import ScrollingColumn from '../components/common/ScrollingColumn';

const ResetPasswordPage = () => {
	return (
		<AuthLayout
			left={<ResetPassword />}
			right={
				<>
					<ScrollingColumn direction="up" />
					<ScrollingColumn direction="down" />
					<ScrollingColumn direction="up" />
				</>
			}
		/>
	);
};
export default ResetPasswordPage;
